import { Component } from "react";
import { Text, Box, Button } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { H2, BodyText } from "src/atoms/typography";
import TextField from "src/components/TextField";
import { SceneLayout } from "src/components/SceneLayout";
import BackButton from "src/components/BackButton";
import IncorrectPasswordDialog from "src/modules/auth/components/IncorrectPasswordDialog";
import LoadableContent from "src/components/LoadableContent";
import IconOnBackground from "src/components/IconOnBackground";

import ForgotPassword from "../../components/ForgotPassword";
import { ReactComponent as FamilyIcon } from "./family.svg";

const log = window.require("electron-log");

class PrefilledLogin extends Component {
  state = {
    email: this.props.email,
    password: "",
    invalidPassword: false,
    isProcessing: false,
    showForgotPassword: false
  };

  handlePasswordChange = ({ target }) => {
    this.setState({ password: target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (this.state.isProcessing) {
      return;
    }
    const { email, password } = this.state;
    const { logIn, onSuccess } = this.props;
    this.setState({ isProcessing: true });
    try {
      await logIn({ username: email, password });
      onSuccess();
    } catch (error) {
      log.error(error);
      this.setState({ invalidPassword: true, isProcessing: false });
      return;
    }
  };
  openForgotPassword = () => {
    this.setState({ showForgotPassword: true });
  };
  closeForgotPassword = () => this.setState({ showForgotPassword: false });

  render() {
    const {
      invalidPassword,
      isProcessing,
      email,
      password,
      showForgotPassword
    } = this.state;
    const { t, onBack } = this.props;
    return (
      <>
        {showForgotPassword && (
          <ForgotPassword onDismiss={this.closeForgotPassword} email={email} />
        )}
        <IncorrectPasswordDialog
          isOpen={invalidPassword}
          onDismiss={() =>
            this.setState({ invalidPassword: false, password: "" })
          }
        />
        <SceneLayout
          as="form"
          onSubmit={this.handleSubmit}
          absolute={
            <BackButton disabled={isProcessing} absolute onClick={onBack} />
          }
          centerProps={{
            width: "320px",
            textAlign: "center"
          }}
          center={
            <>
              <IconOnBackground
                fill="primaryLighther"
                icon={FamilyIcon}
                bg="primaryLight"
              />
              <H2 color="highEmphasis" mt="24px">
                {t("auth.prefilledLogin.heading")}
              </H2>
              <BodyText color="mediumEmphasis" mt="8px">
                {t("auth.prefilledLogin.text")}
              </BodyText>
              <Text
                mt="16px"
                color="highEmphasis"
                fontSize="12px"
                fontWeight="500"
                lineHeight="1.33"
                letterSpacing="0.4px"
              >
                {email}
              </Text>
              <Box width="100%" mt="16px">
                <TextField
                  type="password"
                  required
                  disabled={isProcessing}
                  value={password}
                  onChange={this.handlePasswordChange}
                  placeholder={t("placeholders.password")}
                />
              </Box>
              <Button
                variant="flatPrimary"
                mt="8px"
                type="button"
                onClick={this.openForgotPassword}
                minWidth="120px"
                disabled={isProcessing}
              >
                {t("forgotPassword")}
              </Button>
            </>
          }
          bottomProps={{
            mb: "24px"
          }}
          bottom={
            <>
              <LoadableContent showContent={!isProcessing}>
                <Button
                  variant="containedPrimary"
                  type="submit"
                  minWidth="120px"
                >
                  {t("buttons.logIn")}
                </Button>
              </LoadableContent>
            </>
          }
        />
      </>
    );
  }
}

export default withTranslation()(PrefilledLogin);
